// extracted by mini-css-extract-plugin
export var dividerLine = "_51-3";
export var itemImage = "_51-9";
export var lightDivider = "_51-4";
export var modalContent = "_51-5";
export var modalContentCompact = "_51-6";
export var productCard = "_51-a";
export var productImage = "_51-b";
export var productImageCompact = "_51-7";
export var productImagePlaceholder = "_51-c";
export var productImagePlaceholderCompact = "_51-8";
export var progressBarBackground = "_51-1";
export var progressBarContainer = "_51-0";
export var progressBarFill = "_51-2";